// src/componentes/tienda/tiendaPublica/SelectorColor.js
// Colores del producto como muestras (círculos), al estilo retail. «tonos»: los
// elegidos por el admin con la paleta; sin uno, el tono sale del nombre, y un
// color sin tono reconocido se muestra con su nombre. «disponibles»: los que existen
// en la talla elegida; «conStock»: los que tienen stock en alguna talla. Uno
// con stock pero sin la talla elegida se puede elegir (cambia la talla).
import React from 'react';
import { fondoMuestra, nombreColor, tonosMuestra } from '../../../dominio/coloresProducto';

export const SelectorColor = ({ colores, tonos, disponibles, conStock = disponibles, valor, onElegir, etiqueta,
  compacto = false, max = 0, onMas, deshabilitado = false }) => {
  const recortar = max > 0 && colores.length > max;
  const visibles = recortar ? colores.slice(0, max - 1) : colores;
  const ocultos = colores.length - visibles.length;
  return <div className={`tp-muestras${compacto ? ' tp-muestras--compacto' : ''}`}
    {...(etiqueta ? { role: 'group', 'aria-label': etiqueta } : {})}>
    {visibles.map((color) => {
      const muestra = tonosMuestra(color, tonos);
      const hay = conStock.includes(color);
      const combina = disponibles.includes(color);
      const nombre = nombreColor(color);
      const estado = !hay ? ', sin stock' : !combina ? ', no disponible en la talla elegida' : '';
      return <button key={color} type="button" title={nombre} aria-pressed={valor === color} disabled={deshabilitado || !hay}
        className={`tp-muestra${muestra ? '' : ' tp-muestra--texto'}${hay && !combina ? ' is-sin-combinacion' : ''}`}
        aria-label={`${nombre}${estado}`} onClick={() => onElegir(valor === color ? '' : color)}>
        {muestra ? <span className="tp-muestra-tono" style={{ '--tp-muestra': fondoMuestra(muestra) }} aria-hidden="true" /> : nombre}
      </button>;
    })}
    {ocultos > 0 && <button type="button" className="tp-muestra-mas" onClick={onMas}
      aria-label={`Ver ${ocultos} colores más`}>+{ocultos}</button>}
  </div>;
};
